import type { ReactElement } from 'react';
import { useConfig, useServices, useT } from '../../../app/di';
import type { LoadOptions } from '../../../ui-kit/Combobox/Combobox';
import { PageHeader } from '../../../ui-kit/PageHeader/PageHeader';
import { ApiKeysConnected } from './ApiKeysConnected';
import { toIssueRequest } from './model/api-keys';

// IAM-UC-11, IAM-UC-6.CC-2: ключи всех пользователей; владелец выбирается поиском.
export function ApiKeysAdminPage(): ReactElement {
  const { api } = useServices();
  const { t } = useT();
  const size = useConfig().ui.users.pageSize;
  const loadOwners: LoadOptions = async (query, offset, signal) => {
    const result = await api.identity.searchUsers({ q: query, limit: size + 1, offset }, signal);
    if (!result.success) return null;
    return { items: result.data.slice(0, size).map((user) => ({ value: user.id, label: `${user.displayName} (${user.login})` })), hasMore: result.data.length > size };
  };
  return (
    <div className="u-stack-lg">
      <PageHeader title={t('identity.apiKeys.adminTitle')} subtitle={t('identity.apiKeys.adminSubtitle')} />
      <ApiKeysConnected
        showOwner
        loadOwners={loadOwners}
        list={() => api.identity.allApiKeys()}
        issue={(values) => api.identity.issueApiKey({ ...toIssueRequest(values), userId: values.userId ?? '' })}
        revoke={(keyId) => api.identity.revokeApiKey(keyId)}
        remove={(keyId) => api.identity.deleteApiKey(keyId)}
      />
    </div>
  );
}
